module.exports = __webpack_public_path__ + "static/img/hangzhou.61570f3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/hangzhou.jpeg
// module id = 40sA
// module chunks = 1